<template>
    <b-button
            @click="$emit('click')"
            type="button"
            :class="(typeclass ? typeclass + ' ' : '') + classes"
            variant="ternary"
            :size="typeclass ? 'md' : ''"
            :disabled="disabled"
    >
        <span
                v-if="content"
                class="ml-1 font-weight-bold"
        >
            {{ content }}
        </span>
    </b-button>
</template>

<script>
    import './IconButton.scss';

    export default {
        name: 'IconButton',
        props: {
            typeclass: {
                type: String,
                default: 'icon-button text-gray-700',
            },
            classes: {
                type: String,
                required: true,
            },
            content: {
                type: String,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
